import { Typography,Image, Alert } from "antd";
import TeamElement from "./teamElement";

import Head from "../../../components/sectionHead";
import Nagappa from "../../../assets/images/Ellipse 1.png";
import Suma from "../../../assets/images/Ellipse 2.png";
import Sadananda from "../../../assets/images/Ellipse 3.png";

const { Text } = Typography;

const aboutNagappa = `GS Nagappa's over four decades of leadership experience include growing consumer franchise in beverage alcohol categories across India. He retired as Chief Operating Officer at Diageo India and held various executive roles during his journey to the top. Today, as a  veteran and philanthropist, he continues to passionately work towards building new businesses by understanding new opportunities in Indian market.He has a deep commitment to community and aims to achieve shared success.`;

const aboutSuma = `Suma Sadananda is deeply committed to social causes, which led her to begin her career in the teaching profession. After dedicating time to her family and children, she has embarked on her second innings to pursue her interests. She is passionate about promoting product lines that address and solve local challenges.`;
const aboutSadananda = `Sadananda Murthy is a management and delivery professional with over two decades of global experience in software product development, team leadership, and program management at Fortune 500 companies including Motorola, NetApp, and Broadcom. He specializes in digital transformation, new product development, and operational excellence across diverse software lifecycle methodologies. Passionate about leveraging technology for social impact, education, and community upliftment, he also enjoys reading and writing about technology, processes, and personal insights.`;

export default function Team() {
  return (
    <div className="team container-fluid" id="team">
      <Head title={"Mgmt. Team"} />
      <Text className="team-sub-heading">
      <b>At SamparkBindhu, our team is united by a shared vision and a deep commitment to the values of our community.</b>
      </Text>
      <TeamElement
        imgUrl={Sadananda}
        name="Sadananda Murthy"
        designation="Director, (Tech & Ops)"
        text={aboutSadananda}
      />
      <TeamElement
        imgUrl={Nagappa}
        name="G S Nagappa"
        designation="Director, (Mktg & Sales)"
        text={aboutNagappa}
      />
      <TeamElement
        imgUrl={Suma}
        name="Suma Sadananda"
        designation="Director, Administration"
        text={aboutSuma}
      />
      <button>
        <a href="/teamextended">View more</a>
      </button>
    </div>
  );
}
